import { configService } from '@findy-code/yuffie/services/config';
import { useCallback } from 'react';

const USER_SUCCESS_MODAL = 'userSuccessModal';

export const useUserSuccessModalFacade = () => {
  const setLastShownAt = useCallback(() => {
    configService.setLastShownAt(USER_SUCCESS_MODAL, new Date());
  }, []);

  return { setLastShownAt } as const;
};
